import { SupplierStepModel } from "@/models/supplierStepModel";

export class StepsHelper{
    public static stepSequence(): SupplierStepModel[] {
        return [
            {
                displayName: 'Design & development',
                stepID: 14,
                sequence: 1,
                showDefault: true,
            },
            {
                displayName: 'Raw material',
                stepID: 15,
                sequence: 2,
                showDefault: true,
            },
            {
                displayName: 'Man-made material',
                stepID: 30,
                sequence: 3,
                showDefault: true,
            },
            {
                displayName: 'Natural material',
                stepID: 21,
                sequence: 4,
                showDefault: true,
            },
            {
                displayName: 'Recycled material',
                stepID: 16,
                sequence: 5,
                showDefault: true,
            },
            {
                displayName: 'Cotton harvest',
                stepID: 1,
                sequence: 6,
                showDefault: true,
            },
            {
                displayName: 'Ginning',
                stepID: 2,
                sequence: 7,
                showDefault: true,
            },
            {
                displayName: 'Raw material processing',
                stepID: 39,
                sequence: 8,
                showDefault: true,
            },
            {
                displayName: 'Pulp processing',
                stepID: 48,
                sequence: 9,
                showDefault: true,
            },
            {
                displayName: 'Material trading',
                stepID: 20,
                sequence: 10,
                showDefault: true,
            },
            {
                displayName: 'Tanning',
                stepID: 31,
                sequence: 11,
                showDefault: true,
            },
            {
                displayName: 'Spinning',
                stepID: 3,
                sequence: 12,
                showDefault: true,
            },
            {
                displayName: 'Yarn trading',
                stepID: 22,
                sequence: 13,
                showDefault: true,
            },
            {
                displayName: 'Compounding',
                stepID: 33,
                sequence: 14,
                showDefault: true,
            },
            {
                displayName: 'Material production',
                stepID: 40,
                sequence: 15,
                showDefault: true,
            },
            {
                displayName: 'Paper making',
                stepID: 50,
                sequence: 16,
                showDefault: true,
            },
            {
                displayName: 'Knitting',
                stepID: 4,
                sequence: 17,
                showDefault: true,
            },
            {
                displayName: 'Weaving',
                stepID: 5,
                sequence: 18,
                showDefault: true,
            },
            {
                displayName: 'Webbing',
                stepID: 38,
                sequence: 19,
                showDefault: true,
            },
            {
                displayName: 'Foaming',
                stepID: 53,
                sequence: 20,
                showDefault: true,
            },
            {
                displayName: 'Foam slicing',//TTD-5872: new step for sprint 34
                stepID: 55,
                sequence: 21,
                showDefault: true,
            },
            {
                displayName: 'Fabric trading',
                stepID: 23,
                sequence: 22,
                showDefault: true,
            },
            {
                displayName: 'Forming',
                stepID: 43,
                sequence: 23,
                showDefault: true,
            },
            {
                displayName: 'Melting',
                stepID: 47,
                sequence: 24,
                showDefault: true,
            },
            {
                displayName: 'Drying',
                stepID: 44,
                sequence: 25,
                showDefault: true,
            },
            {
                displayName: 'Dyeing',
                stepID: 6,
                sequence: 26,
                showDefault: true,
            },
            {
                displayName: 'Colouring',
                stepID: 52,
                sequence: 27,
                showDefault: true,
            },
            {
                displayName: 'Glazing',
                stepID: 45,
                sequence: 28,
                showDefault: true,
            },
            {
                displayName: 'Printing',
                stepID: 8,
                sequence: 29,
                showDefault: true,
            },
            {
                displayName: 'Coating',
                stepID: 35,
                sequence: 30,
                showDefault: true,
            },
            {
                displayName: 'Laminating',
                stepID: 36,
                sequence: 31,
                showDefault: true,
            },
            {
                displayName: 'Firing',
                stepID: 46,
                sequence: 32,
                showDefault: true,
            },
            {
                displayName: 'Bleaching',
                stepID: 49,
                sequence: 33,
                showDefault: true,
            },
            {
                displayName: 'Grinding',
                stepID: 51,
                sequence: 34,
                showDefault: true,
            },
            {
                displayName: 'Washing',
                stepID: 7,
                sequence: 35,
                showDefault: true,
            },
            {
                displayName: 'Embroidery',
                stepID: 9,
                sequence: 36,
                showDefault: true,
            },
            {
                displayName: 'Component production',
                stepID: 41,
                sequence: 37,
                showDefault: true,
            },
            {
                displayName: 'Accessories',
                stepID: 17,
                sequence: 38,
                showDefault: true,
            },
            {
                displayName: 'Trims',
                stepID: 18,
                sequence: 39,
                showDefault: true,
            },
            {
                displayName: 'Cutting',
                stepID: 24,
                sequence: 40,
                showDefault: true,
            },
            {
                displayName: 'Moulding', // TTD-5371, sprint 31
                stepID: 34,
                sequence: 41,
                showDefault: true,
            },
            {
                displayName: 'Sewing',
                stepID: 25,
                sequence: 42,
                showDefault: true,
            },
            {
                displayName: 'Confectioning',
                stepID: 10,
                sequence: 43,
                showDefault: true,
            },
            {
                displayName: 'Manufacturing',
                stepID: 37,
                sequence: 44,
                showDefault: true,
            },
            {
                displayName: 'Assembling',
                stepID: 32,
                sequence: 45,
                showDefault: true,
            },
            {
                displayName: 'Finishing',
                stepID: 26,
                sequence: 46,
                showDefault: true,
            },
            {
                displayName: 'Labels',
                stepID: 28,
                sequence: 47,
                showDefault: true,
            },
            {
                displayName: 'Packing',
                stepID: 27,
                sequence: 48,
                showDefault: true,
            },
            {
                displayName: 'Packing material',
                stepID: 42,
                sequence: 49,
                showDefault: true,
            },
            {
                displayName: 'Product trading', //TTD-5872: new step for sprint 34
                stepID: 54,
                sequence: 50,
                showDefault: true,
            },
            {
                displayName: 'Exporting', //TTD-5872: swap the sequence with Transport for sprint 34
                stepID: 29,
                sequence: 51,
                showDefault: true,
            },
            {
                displayName: 'Transport',
                stepID: 11,
                sequence: 52,
                showDefault: true,
            },
            
            {
                displayName: 'Importing',
                stepID: 12,
                sequence: 53,
                showDefault: true,
            },
            {
                displayName: 'Warehousing',
                stepID: 13,
                sequence: 54,
                showDefault: true,
            },
            {
                displayName: 'Retailing',
                stepID: 19,
                sequence: 55,
                showDefault: true,
            }
        ]
    }
}